import Milling from './milling';
export default Milling;
